import { Avatar, Space, Typography } from "antd";
import { Link } from "react-router";

import { ROUTES, SECTIONS, sectionSurface } from "@/shared/config";

/**
 * Пользователь в таблице заявок: имя ссылкой на карточку и telegram_id рядом.
 *
 * Именно так оператор его и ищет — по имени из жалобы или по id из лога.
 *
 * Аватар — буква из имени: настоящих фотографий у бота нет, а якорь слева
 * задаёт строке начало, по которому взгляд идёт вниз по колонке.
 */
export function UserCell({
  id,
  username,
  firstName,
  telegramId,
}: {
  id: number;
  username?: string | null;
  firstName?: string | null;
  telegramId: number;
}) {
  const title = username ? `@${username}` : (firstName ?? `#${String(id)}`);
  const { color } = SECTIONS.users;
  // Первая буква имени, а не «@» и не «#»: у половины строк подпись начинается
  // с одного и того же служебного символа, и аватары сливаются в столбик.
  const initial = (username ?? firstName ?? String(id)).replace(/^[@#]/, "").charAt(0).toUpperCase();

  return (
    <Space size={10} align="center">
      <Avatar
        size={32}
        style={{ background: sectionSurface(color), color, fontWeight: 600, flex: "none" }}
      >
        {initial}
      </Avatar>
      <Space orientation="vertical" size={0}>
        <Link to={ROUTES.user(id)} style={{ fontWeight: 500 }}>
          {title}
        </Link>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {telegramId}
        </Typography.Text>
      </Space>
    </Space>
  );
}
